import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import OutputHandler from './components/validation/OutputHandler';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import store from './redux/store';
import { Provider } from 'react-redux';
import { StytchProvider } from '@stytch/react';
import { StytchUIClient } from '@stytch/vanilla-js';
import TokenAuthenticator from './components/auth/TokenAuthenticator';
import { ThemeModeProvider } from './theme/ThemeModeContext';
import AddDeviceContainer from './components/devices/DeviceList';
import FlowList from './components/flows/FlowList';
import TestHistoryPage from './components/testHistory/TestHistoryPage';
import TestHistoryDetail from './components/testHistory/TestHistoryDetail';
import AppFlowsPage from './components/appFlows/AppFlowsPage';
import ActiveRunsPage from './components/ActiveRuns/ActiveRunsPage';
import ActiveRunsSummaryPage from './components/ActiveRuns/ActiveRunsSummaryPage';
import FailedRunsPage from './components/ActiveRuns/FailedRunsPage';
import LocatorDriftPage from './components/locatorDrift/LocatorDriftPage';
import LocatorsPage from './components/locatorManagement/LocatorsPage';

// We initialize the Stytch client using our project's public token which can be found in the Stytch dashboard
// optional object for configuring SDK cookie behavior, currently showing defaults
const stytchOptions = {
  cookieOptions: {
    opaqueTokenCookieName: 'stytch_session',
    jwtCookieName: 'stytch_session_jwt',
    path: '/',
    availableToSubdomains: false,
    domain: '',
  },
};

const stytchClient = new StytchUIClient(process.env.REACT_APP_STYTCH_PUBLIC_TOKEN, stytchOptions);

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: 'beacons/*',
        element: <OutputHandler />,
      },
      {
        path: 'devices/*',
        element: <AddDeviceContainer />,
      },
      {
        path: 'flows/*',
        element: <FlowList />,
      },
      {
        path: 'test-history',
        element: <TestHistoryPage />,
      },
      {
        path: 'test-history/:id',
        element: <TestHistoryDetail />,
      },
      {
        path: 'app-flows',
        element: <AppFlowsPage />,
      },
      {
        path: 'active-runs',
        element: <ActiveRunsPage />,
      },
      {
        path: 'active-runs/summary',
        element: <ActiveRunsSummaryPage />,
      },
      {
        path: 'failed-runs',
        element: <FailedRunsPage />,
      },
      {
        path: 'locator-drift',
        element: <LocatorDriftPage />,
      },
      {
        path: 'locators',
        element: <LocatorsPage />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StytchProvider stytch={stytchClient}>
      <TokenAuthenticator>
        <Provider store={store}>
          <ThemeModeProvider>
            <RouterProvider router={router} />
          </ThemeModeProvider>
        </Provider>
      </TokenAuthenticator>
    </StytchProvider>
  </React.StrictMode>,
);
